import React, { useEffect, useState, useRef, useContext } from 'react'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import '../css/landing.css'
import Rightcontainer from '../Components/Rightcontainer'
import Downloadbutton from '../Components/Downloadbutton'
import DownloadPopup from '../Components/DownloadPopup'
import io from '../Components/socket'
import Header from '../Components/Header'
import { Token } from '@mui/icons-material'
// import SliderCode from '../Components/SliderCode'
import { LanguageContext } from '../Components/LanguageContext'
import { useTheme } from '../../ThemeContext'

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false)
  const [showDownloadPopup, setShowDownloadPopup] = useState(true)
  // const [userAllData, setUserAllData] = useState()

  // language
  const translations = {
    hi: { Tournaments: 'प्रतियोगिता' },
    en: { Tournaments: 'Tournaments' },
  };


  const MyData = localStorage.getItem('meData')
  const meedata = JSON.parse(MyData)
  const { language } = useContext(LanguageContext);

  const addsetting = localStorage.getItem('sitSetting')
  const addCaseSetting = JSON.parse(addsetting)
  // console.log(addCaseSetting);

  // const role = async () => {
  //   const access_token = localStorage.getItem('token')
  //   io.emit('getprofile', access_token)
  //   io.on('setProfile', data => {
  //     // setUserAllData(data)
  //   })
  // }

  useEffect(() => {
    // role()
  }, [])

  // change theme 
  const { theme, toggleTheme } = useTheme();

  const styles = {
    backgroundColor: theme === 'light' ? '#000' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
    // padding: '20px',
    // margin: '20px',
  };

  const styles3 = {
    backgroundColor: theme === 'light' ? '#26355D' : '#27241b',
    color: theme === 'light' ? '#fff' : '#fff',
  };

  const [promptInstall, setPromptInstall] = useState(null);

  const [supportsPWA, setSupportsPWA] = useState(
    localStorage.getItem("supportsPWA") === "true"
  );

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();

      setPromptInstall(e);
      setSupportsPWA(true);

      localStorage.setItem("supportsPWA", "true");

      // globally save event
      window.deferredPrompt = e;
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () =>
      window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onInstallClick = async () => {

    const prompt =
      promptInstall || window.deferredPrompt;

    if (!prompt) return;

    prompt.prompt();

    const choice = await prompt.userChoice;

    if (choice.outcome === "accepted") {

      localStorage.removeItem("supportsPWA");

      setSupportsPWA(false);

      window.deferredPrompt = null;
    }
  };

  useEffect(() => {

    window.addEventListener("appinstalled", () => {

      localStorage.removeItem("supportsPWA");

      setSupportsPWA(false);

      window.deferredPrompt = null;

    });

  }, []);

  return (
    <>
      {/* {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />} */}
      <div className='leftContainer ' style={{ ...styles, }}>

        <div className=' Orher_page_main_section' >

          <div className='main-area' >
            {
              JSON.parse(localStorage.getItem("sitSetting"))?.site_message && (
                <div className="rk_notice_card">

                  <div className="rk_notice_icon">
                    ⭐
                  </div>

                  <div className="rk_notice_content">
                    <span className="rk_notice_label">
                      NOTICE
                    </span>

                    <h5 className="rk_notice_text">
                      {JSON.parse(localStorage.getItem("sitSetting"))?.site_message}
                    </h5>
                  </div>

                  <div className="rk_notice_spark">
                    ✦
                  </div>

                </div>
              )
            }
            {/* <div className="mlk_open_battle_banner">

              <div className="mlk_corner_left"></div>
              <div className="mlk_corner_right"></div>

              <div className="mlk_banner_side">
                ⚔️
              </div>

              <div className="mlk_banner_center">

                <h2>OUR TOURNAMENTS</h2>

                <p>
                  Choose your battle and win big
                </p>

                <div className="mlk_banner_line">
                  <span></span>
                  <i></i>
                  <span></span>
                </div>

              </div>

              <div className="mlk_banner_side">
                ⚔️
              </div>

            </div> */}
            <div className='mlk_open_battle_banner_heading'>
              <img src='../images/our-games.png' className='img-fluid' />
            </div>

            {/* OUR TOURNAMENTS BANNER */}



            {/* GAMES */}

            <section className="mlk_games_section">

              <div className="mlk_games_grid">

                {/* LUDO */}

                <Link
                  className="mlk_game_link"
                  to="/Homepage/ludoClassicManual"
                >

                  <div className="mlk_game_card">

                    {/* <span className="mlk_live_tag">
                      <span className="mlk_live_dot"></span>
                      LIVE
                    </span> */}

                    <img
                      src="./mainimage/ludoClassicc.png"
                      alt=""
                      className="mlk_game_image"
                    />

                  </div>

                </Link>

                {/* SUPPORT */}

                <a
                  href={
                    JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport
                  }
                  target="_blank"
                  rel="noreferrer"
                  className="mlk_game_link"
                >

                  <div className="mlk_game_card">

                    {/* <span className="mlk_live_tag">
                      <span className="mlk_live_dot"></span>
                      LIVE
                    </span> */}

                    <img
                      src="./mainimage/ludo-support.png"
                      alt=""
                      className="mlk_game_image"
                    />

                  </div>

                </a>

              </div>

            </section>


            {/* EXPLORE SERVICES */}

            {/* <div className="mlk_services_banner">

              <span>
                EXPLORE OUR SERVICES
              </span>

            </div> */}

            {/* Services Banner */}
            {/* <div className="services_banner_container ">
              <div
                id="premiumBannerSlider"
                className="carousel slide  premium_banner_slider"
                data-bs-ride="carousel"
                data-bs-interval="3000"
              >
                <div className="carousel-indicators">
                  <button
                    type="button"
                    data-bs-target="#premiumBannerSlider"
                    data-bs-slide-to="0"
                    className="active"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#premiumBannerSlider"
                    data-bs-slide-to="1"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#premiumBannerSlider"
                    data-bs-slide-to="2"
                  ></button>
                </div>

                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      src="./images/first_banner.png"
                      className="d-block w-100"
                      alt="Banner 1"
                    />
                  </div>

                  <div className="carousel-item">
                    <img
                      src="./images/second_banner.png"
                      className="d-block w-100"
                      alt="Banner 2"
                    />
                  </div>

                  <div className="carousel-item">
                    <img
                      src="./images/third_banner.png"
                      className="d-block w-100"
                      alt="Banner 3"
                    />
                  </div>
                </div>

                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#premiumBannerSlider"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon"></span>
                </button>

                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#premiumBannerSlider"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon"></span>
                </button>
              </div>
            </div> */}

            {/* =====================================================
    FEATURE CARDS
===================================================== */}
            <div className="rk_feature_heading">
              <span className="rk_feature_heading_line"></span>

              <h3>Why Choose Us?</h3>

              <span className="rk_feature_heading_line"></span>
            </div>
            <div className="rk_feature_grid">

              {/* ================= INSTANT WITHDRAWAL ================= */}
              <Link
                to="/wallet"
                className="rk_feature_card rk_feature_wallet"
              >

                <div className="rk_feature_icon_wrap">
                  <img
                    src="./wallet-features.png"
                    alt="Instant Withdrawal"
                    className="rk_feature_icon"
                  />
                </div>

                <div className="rk_feature_content">

                  <h4>
                    INSTANT
                    <br />
                    WITHDRAWAL
                  </h4>

                  <p>
                    Fast & Secure
                  </p>

                </div>

                {/* <span className="rk_feature_arrow">
                  →
                </span> */}

              </Link>


              {/* ================= SECURE ================= */}
              <Link
                to="/profile"
                className="rk_feature_card rk_feature_secure"
              >

                <div className="rk_feature_icon_wrap">
                  <img
                    src="./secure-features.png"
                    alt="Secure"
                    className="rk_feature_icon"
                  />
                </div>

                <div className="rk_feature_content">

                  <h4>
                    100%
                    <br />
                    SECURE
                  </h4>

                  <p>
                    Safe & Trusted
                  </p>

                </div>

                {/* <span className="rk_feature_arrow">
                  →
                </span> */}

              </Link>


              {/* ================= SUPPORT ================= */}
              <Link
                to="/support"
                className="rk_feature_card rk_feature_support"
              >

                <div className="rk_feature_icon_wrap">
                  <img
                    src="./support-features.png"
                    alt="Support"
                    className="rk_feature_icon"
                  />
                </div>

                <div className="rk_feature_content">

                  <h4>
                    24/7
                    <br />
                    SUPPORT
                  </h4>

                  <p>
                    Always Here
                  </p>

                </div>

                {/* <span className="rk_feature_arrow">
                  →
                </span> */}

              </Link>


              {/* ================= REFER & EARN ================= */}
              <Link
                to="/refer"
                className="rk_feature_card rk_feature_refer"
              >

                <div className="rk_feature_icon_wrap">
                  <img
                    src="./refer-features.png"
                    alt="Refer & Earn"
                    className="rk_feature_icon"
                  />
                </div>

                <div className="rk_feature_content">

                  <h4>
                    REFER & EARN
                  </h4>

                  <p>
                    Invite & Earn More
                  </p>

                </div>

                {/* <span className="rk_feature_arrow">
                  →
                </span> */}

              </Link>

            </div>

            {/* <div className="quick_action_wrapper">

              {supportsPWA && (
                <div
                  className="quick_action_card"
                  onClick={onInstallClick}
                >
                  <div className="quick_action_icon">
                    📲
                  </div>

                  <div className="quick_action_text">
                    <h4>Install App</h4>
                    <span>Fast access</span>
                  </div>
                </div>
              )}

              <div
                className="quick_action_card"
                onClick={toggleTheme}
              >
                <div className="quick_action_icon">
                  {theme === "light" ? "🌙" : "☀️"}
                </div>

                <div className="quick_action_text">
                  <h4>
                    {theme === "light"
                      ? "Dark Mode"
                      : "Light Mode"}
                  </h4>

                  <span>Change Theme</span>
                </div>
              </div>

            </div> */}

            <div className='downloadButton'>
              <Downloadbutton />
            </div>
          </div>
        </div>
      </div>
      <div className="support_samll_card_btn_type whatsap_btn">
        {JSON.parse(localStorage.getItem("sitSetting")) ==
          "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))
          ?.whatsappSupport ? (
          <>
            <a
              href={
                JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.whatsappSupport
              }
              target="_blank"
            >
              {/* <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                alt=""
              /> */}
            </a>
          </>
        ) : (
          ""
        )}
      </div>
      <div className="support_samll_card_btn_type whatsap_btn" style={{ marginBottom: "65px" }}>
        {JSON.parse(localStorage.getItem("sitSetting")) ==
          "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))
          ?.CompanyMobile ? (
          <>
            {/* <a
              href={
                `tel:${JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.CompanyMobile}`
              }
              target="_blank"
            >
              <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/phone.png"}
                alt=""
              />
            </a> */}
          </>
        ) : (
          ""
        )}

      </div>

      <div className='rightContainer'>
        <Rightcontainer />
      </div>
      {/* WHATSAPP CHANNEL FLOATING BUTTON */}
      {/* <a
        href="https://whatsapp.com/channel/0029Vb7csxR4Crfed8O6Qy2t"
        target="_blank"
        rel="noreferrer"
        className="join-channel-btn"
      >
        🎁 Join Now
      </a> */}

    </>
  )
}
